"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SecondaryButton = exports.PrimaryButton = exports.ExpandableButton = exports.DestructiveButton = exports.DangerButton = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
var _reactUse = require("react-use");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _loading_spinner = _interopRequireDefault(require("../loading_spinner"));
var _theme = require("./theme");
var _grid = require("../../layouts/grid");
var _shared = require("./shared");
var _arrow_down = _interopRequireDefault(require("../../icons/arrow_down"));
var _constants = require("../../utils/constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var defaultButtonProps = {
  disabled: false,
  loading: false
};
var HiddenText = _styledComponents["default"].span.withConfig({
  displayName: "buttons__HiddenText"
})(["visibility:hidden;"]);
var AlignedLoadingSpinner = (0, _styledComponents["default"])(_loading_spinner["default"]).attrs({
  size: 'small'
}).withConfig({
  displayName: "buttons__AlignedLoadingSpinner"
})(["position:absolute;left:0;right:0;top:0;bottom:0;margin:auto;"]);
var ButtonWrapper = _styledComponents["default"].button.withConfig({
  displayName: "buttons__ButtonWrapper"
})(["padding:0.5rem 1.5rem;border-radius:25px;text-decoration:none;transition:background 0.15s,border-color 0.15s,color 0.15s,box-shadow 0.15s;&:hover{text-decoration:none;}", " ", ";&:active{box-shadow:none;}"], _shared.CommonButtonStyles, function (_ref) {
  var theme = _ref.extensibleTheme;
  return "\n    background: ".concat(theme["default"].backgroundColor, ";\n    border: solid 1px ").concat(theme["default"].borderColor, ";\n    color: ").concat(theme["default"].color, ";\n\n    &:focus {\n      background: ").concat(theme.hover.backgroundColor, ";\n      color: ").concat(theme.hover.color, ";\n      outline: -webkit-focus-ring-color auto 1px;\n    }\n\n    &:hover {\n      background: ").concat(theme.hover.backgroundColor, ";\n      border-color: ").concat(theme.hover.borderColor, ";\n      color: ").concat(theme.hover.color, ";\n\n      box-shadow: 0 2px 6px rgba(0, 0, 0, ").concat(theme.hover.dropShadowOpacity, ");\n    }\n\n    &:active {\n      background: ").concat(theme.active.backgroundColor, ";\n      border-color: ").concat(theme.active.borderColor, ";\n      color: ").concat(theme.active.color, ";\n    }\n  ");
});
var EllipsifiedGrid = (0, _styledComponents["default"])(_grid.Grid).withConfig({
  displayName: "buttons__EllipsifiedGrid"
})(["max-width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"]);
var IconWrapper = _styledComponents["default"].div.withConfig({
  displayName: "buttons__IconWrapper"
})(["display:flex;", ";", ";"], function (props) {
  return props.position === 'left' && "margin-right 4px";
}, function (props) {
  return props.position === 'right' && "margin-left: 4px";
});
var ThemeableButton = function ThemeableButton(props) {
  var children = props.children,
    icon = props.icon,
    _props$iconPosition = props.iconPosition,
    iconPosition = _props$iconPosition === void 0 ? 'left' : _props$iconPosition,
    theme = props.theme,
    disabled = props.disabled,
    onClick = props.onClick,
    className = props.className,
    loading = props.loading,
    _props$as = props.as,
    as = _props$as === void 0 ? 'button' : _props$as,
    expandable = props.expandable,
    _props$type = props.type,
    type = _props$type === void 0 ? 'button' : _props$type;
  var buttonRef = React.useRef(null);
  var isHovering = (0, _reactUse.useHoverDirty)(buttonRef);
  var styledIcon = icon && /*#__PURE__*/React.createElement(IconWrapper, {
    position: iconPosition
  }, /*#__PURE__*/React.createElement(icon, {
    color: isHovering ? theme.hover.iconColor : theme["default"].iconColor,
    size: 'sm'
  }));
  var childrenWithIcon = /*#__PURE__*/React.createElement(_grid.Grid, {
    container: true,
    spacing: 1,
    alignItems: "center",
    justifyContent: "center"
  }, iconPosition === 'left' && styledIcon, /*#__PURE__*/React.createElement(EllipsifiedGrid, {
    item: true,
    xs: true,
    title: children
  }, children), iconPosition === 'right' && styledIcon, expandable && /*#__PURE__*/React.createElement(_arrow_down["default"], {
    color: isHovering ? theme.hover.iconColor : theme["default"].iconColor
  }));
  var showLoading = loading && theme.loadingSpinnerFlavor;
  var buttonContent = showLoading ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AlignedLoadingSpinner, {
    "data-provides": "loading-spinner",
    flavor: theme.loadingSpinnerFlavor
  }), /*#__PURE__*/React.createElement(HiddenText, null, childrenWithIcon)) : childrenWithIcon;
  return /*#__PURE__*/React.createElement(ButtonWrapper, (0, _extends2["default"])({
    as: as,
    ref: buttonRef,
    extensibleTheme: theme,
    disabled: disabled,
    "aria-disabled": disabled,
    onClick: onClick,
    className: className,
    type: type
  }, (0, _constants.getDataProvidesProps)(props)), buttonContent);
};
ThemeableButton.defaultProps = defaultButtonProps;
var PrimaryButton = exports.PrimaryButton = function PrimaryButton(props) {
  return /*#__PURE__*/React.createElement(ThemeableButton, (0, _extends2["default"])({}, props, {
    theme: _theme.PrimaryButtonTheme
  }));
};
PrimaryButton.displayName = 'PrimaryButton';
PrimaryButton.defaultProps = _objectSpread(_objectSpread({}, defaultButtonProps), {}, {
  'data-provides': 'primary-button'
});
var SecondaryButton = exports.SecondaryButton = function SecondaryButton(props) {
  return /*#__PURE__*/React.createElement(ThemeableButton, (0, _extends2["default"])({}, props, {
    theme: _theme.SecondaryButtonTheme
  }));
};
SecondaryButton.displayName = 'SecondaryButton';
SecondaryButton.defaultProps = _objectSpread(_objectSpread({}, defaultButtonProps), {}, {
  'data-provides': 'secondary-button'
});
var ExpandableButton = exports.ExpandableButton = function ExpandableButton(props) {
  return /*#__PURE__*/React.createElement(ThemeableButton, (0, _extends2["default"])({}, props, {
    expandable: true,
    theme: _theme.SecondaryButtonTheme
  }));
};
ExpandableButton.displayName = 'ExpandableButton';
ExpandableButton.defaultProps = _objectSpread(_objectSpread({}, defaultButtonProps), {}, {
  'data-provides': 'expandable-button'
});
var DangerButton = exports.DangerButton = function DangerButton(props) {
  return /*#__PURE__*/React.createElement(ThemeableButton, (0, _extends2["default"])({}, props, {
    theme: _theme.DangerButtonTheme
  }));
};
DangerButton.displayName = 'DangerButton';
DangerButton.defaultProps = _objectSpread(_objectSpread({}, defaultButtonProps), {}, {
  'data-provides': 'danger-button'
});
var DestructiveButton = exports.DestructiveButton = function DestructiveButton(props) {
  return /*#__PURE__*/React.createElement(ThemeableButton, (0, _extends2["default"])({}, props, {
    theme: _theme.DestructiveButtonTheme
  }));
};
DestructiveButton.displayName = 'DestructiveButton';
DestructiveButton.defaultProps = _objectSpread(_objectSpread({}, defaultButtonProps), {}, {
  'data-provides': 'destructive-button'
});